import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { dispatch } from '../../../hooks/useEventBus';
import useEventBus from '../../../hooks/useEventBus';
import {
  getLocationCookie,
  setLocationCookie
} from '../../helpers';

const Geolocator = props => {
  const {
    endpoint,
    renderInfo,
    locationCookieName,
    locationCookieExpirationInDays
  } = props;

  const [isLoading, setIsLoading] = useState(true);

  const getZipCodeLocation = (
    value,
    country = null,
    firstSearch = false,
    payloadModule = ''
  ) => {
    setIsLoading(true);
    const cookieData = getLocationCookie();

    if (cookieData && cookieData.LastSearchValue === value && !firstSearch) {
      dispatch({
        type: 'geolocation-received',
        payload: {
          sameSearchValue: true,
          Module: payloadModule
        }
      });
      setIsLoading(false);
      return;
    }

    fetch(`${endpoint}?value=${value}${country ? ` country=${country}` : ''}`)
      .then(response => response.json())
      .then(data => {
        if (data.Error) {
          setIsLoading(false);
          dispatch({
            type: 'geolocation-received',
            payload: {
              error: true
            }
          });
        } else {
          const newData = {
            ...data,
            LastSearchValue: value,
            Country: country
          };
          setLocationCookie(newData);
          dispatch({
            type: 'geolocation-received',
            payload: {
              Latitude: newData.Latitude,
              Longitude: newData.Longitude,
              IsState: newData.isState,
              State: newData.State,
              LastSearchValue: newData.LastSearchValue,
              Country: country,
              Module: payloadModule
            }
          });
        }
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch('loading-geolocator');
    const cookieLocationInfo = getLocationCookie();
    if (!cookieLocationInfo && endpoint) {
      fetch(endpoint)
        .then(response => response.json())
        .then(data => {
          const newData = {
            ...data
          };

          Cookies.set(locationCookieName, JSON.stringify(newData), {
            expires: parseInt(locationCookieExpirationInDays) || 7
          });
          setIsLoading(false);
        })
        .catch(error => {
          console.error('Error:', error);
          setIsLoading(false);
        });
    }
    if (cookieLocationInfo) setIsLoading(false);
  }, []);

  useEffect(() => {
    if (isLoading) return;
    dispatch('geolocator-loaded');
  }, [isLoading]);

  useEventBus(
    'get-zip-geolocation',
    ({ payload }) => {
      getZipCodeLocation(
        payload.value,
        payload.country,
        payload.firstSearch,
        payload.moduleName
      );
    },
    []
  );

  if (renderInfo !== 'true') return null;

  if (isLoading || getLocationCookie() === null) return <p>Loading ...</p>;

  return (
    <div className="geolocator_info">
      <p>Geolocator Info:</p>
      <p>Latitude: {getLocationCookie().Latitude}</p>
      <p>Longitude: {getLocationCookie().Longitude}</p>
      <p>IP: {getLocationCookie().IP}</p>
      <p>State: {getLocationCookie().State}</p>
      <p>SearchValue: {getLocationCookie().SearchValue}</p>
    </div>
  );
};

export default Geolocator;
